import { Button, Dialog, DialogActions, Box, DialogContent, TextField, IconButton, DialogTitle, Typography, FormHelperText, Select, MenuItem, Divider } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setMachineNoteDetailsData } from '../../../redux/machineNoteDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/machines/addMachineNote.css';

export const EditMachineNote = ({ editNoteData, setEditNoteData }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const machineNoteDetailsData = useSelector((state) => state?.MachineNoteDetailsData);

    const [errMsg, setErrMsg] = useState(null);

    const formik = useFormik({
        initialValues: {
            machine_id: machineNoteDetailsData.machine_id,
            type: machineNoteDetailsData?.type || '',
            message: machineNoteDetailsData?.message || '',
        },
        validationSchema: Yup.object().shape({
            machine_id: Yup.string().required(t('isRequired')),
            type: Yup.string().required(t('isRequired')),
            message: Yup.string().required(t('isRequired')),
        }),
        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`machine-note/${machineNoteDetailsData?.id}`, values);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setMachineNoteDetailsData(response.data));
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier la remarque de la machine' }));
                    setEditNoteData(false);
                }
            } catch (error) {
                setErrMsg(error.message);
                console.error('Error updating machine note:', error);
                CustomErrorLogger(error, "error updating machine note");
            }
        },
    });

    const { handleSubmit, values, touched, errors, handleChange, handleBlur } = formik;

    const handleClose = useCallback(() => {
        setEditNoteData(false);
    }, [setEditNoteData]);

    return (
        <Dialog open={editNoteData} fullWidth maxWidth='md'>
            <IconButton onClick={handleClose} className='addMachineNote_icon_button'>
                <Iconify icon="material-symbols:close" className='addMachineNote_close_icon' />
            </IconButton>
            <DialogTitle className='addMachineNote_dialog_title'>Modifier une remarque</DialogTitle>
            <Divider />
            <form onSubmit={handleSubmit} >
                {errMsg && <Typography className='errMsg'>{errMsg}</Typography>}
                <DialogContent className='addMachineNote_dialog_content'>
                    <Box className="addMachineNote_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addMachineNoteInputTitle">Type</FormHelperText>
                        <Select
                            fullWidth
                            value={values.type}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="type"
                            className="addMachineNote_select_metier"
                            error={touched.type && Boolean(errors.type)}
                            displayEmpty
                            inputProps={{ 'aria-describedby': 'outlined-weight-helper-text' }}
                        >
                            <MenuItem value="Securite">{t('Sécurité')}</MenuItem>
                            <MenuItem value="Maintenance">{t('Maintenance')}</MenuItem>
                            <MenuItem value="Information">{t('Information')}</MenuItem>
                            <MenuItem value="Autre">{t('Autre')}</MenuItem>
                        </Select>
                        {touched.type && errors.type && (
                            <FormHelperText error className='addMachineNote_err_helper_select'>{errors.type}</FormHelperText>
                        )}
                    </Box>
                    <Box className="addMachineNote_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addMachineNoteInputTitle">Message</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.message}
                            className='addMachineNote_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="message"
                            multiline
                            rows={6}
                            error={touched.message && Boolean(errors.message)}
                            helperText={touched.message && errors.message}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='addMachineNote_dialog_actions'>
                    <Button className='addMachineNote_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
                    <Button className='addMachineNote_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};